/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Category_Subtitle_ReadonlyInputs */

const vi_shop_category_subtitle_readonly = /** @type {(inputs: Shop_Category_Subtitle_ReadonlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dùng chung web + Zalo Mini App.`)
};

/**

* @param {Shop_Category_Subtitle_ReadonlyInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_category_subtitle_readonly = /** @type {((inputs?: Shop_Category_Subtitle_ReadonlyInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Category_Subtitle_ReadonlyInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_category_subtitle_readonly(inputs)
});